import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PagosSuscripcionView from './PagosSuscripcionView';
import * as ROUTES from '../../../../router/Routes';

const PagosSuscripcionModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.pagosSuscripcion}
      routes={[ROUTES.root, ROUTES.suscripciones]}
    >
      <PagosSuscripcionView />
    </ContainerTemplate>
  );
};

export default PagosSuscripcionModule;
